import { border, ursaColors, lodestarColors, typography, motion } from "@smartsheet/design-tokens";
import { toRgba } from "../../constants/colors";
import { themed } from "../../util/theme";

export const checkboxColors = themed({
    check: {
        background: {
            rest: {
                unchecked: lodestarColors.neutralLight40,
                checked: {
                    "lodestar-light": lodestarColors.buttonPrimary,
                    oldestar: "#0073ec",
                    "ursa-light": ursaColors.blue500,
                },
            },
            hover: {
                unchecked: {
                    "lodestar-light": lodestarColors.neutralLight10,
                    oldestar: "#f3f3f3",
                    "ursa-light": ursaColors.neutral50,
                },
                checked: {
                    "lodestar-light": lodestarColors.buttonPrimary,
                    oldestar: "#005cbc",
                    "ursa-light": ursaColors.blue600,
                },
            },
            active: {
                unchecked: {
                    "lodestar-light": lodestarColors.neutralLight10,
                    oldestar: "#f3f3f3",
                    "ursa-light": ursaColors.neutral75,
                },
                checked: {
                    "lodestar-light": lodestarColors.buttonPrimary,
                    oldestar: "#005cbc",
                    "ursa-light": ursaColors.blue700,
                },
            },
            disabled: {
                unchecked: lodestarColors.neutralLight40,
                checked: {
                    "lodestar-light": toRgba(lodestarColors.buttonPrimary, 0.4),
                    oldestar: toRgba("#0073ec", 0.4),
                    "ursa-light": ursaColors.blue200,
                },
            },
            invalid: {
                // Invalid bg styles are the same as valid bg styles.
                rest: {
                    checked: {
                        "lodestar-light": lodestarColors.buttonDestructive,
                        "ursa-light": ursaColors.red500,
                    },
                },
                hover: {
                    checked: {
                        "lodestar-light": lodestarColors.buttonDestructive,
                        "ursa-light": ursaColors.red600,
                    },
                },
                active: {
                    checked: {
                        "lodestar-light": lodestarColors.buttonDestructive,
                        "ursa-light": ursaColors.red700,
                    },
                },
            },
        },
        border: {
            rest: {
                unchecked: {
                    "lodestar-light": lodestarColors.neutralAccessible,
                    oldestar: "#cccccc",
                    "ursa-light": ursaColors.neutral200,
                },
                checked: "transparent",
            },
            hover: {
                unchecked: {
                    "lodestar-light": lodestarColors.neutralAccessible,
                    oldestar: "#c3c3c3",
                    "ursa-light": ursaColors.neutral200,
                },
                checked: "transparent",
            },
            active: {
                unchecked: {
                    "lodestar-light": lodestarColors.neutralAccessible,
                    oldestar: "#c3c3c3",
                    "ursa-light": ursaColors.neutral200,
                },
                checked: "transparent",
            },
            disabled: {
                unchecked: {
                    "lodestar-light": toRgba(lodestarColors.neutralAccessible, 0.4),
                    oldestar: toRgba(lodestarColors.neutralAccessible, 0.3),
                    "ursa-light": ursaColors.neutral75,
                },
                checked: "transparent",
            },
            invalid: {
                rest: {
                    unchecked: {
                        "lodestar-light": lodestarColors.buttonDestructive,
                        "ursa-light": ursaColors.red500,
                    },
                    checked: "transparent",
                },
                hover: {
                    unchecked: {
                        "lodestar-light": lodestarColors.buttonDestructive,
                        "ursa-light": ursaColors.red600,
                    },
                    checked: "transparent",
                },
                active: {
                    unchecked: {
                        "lodestar-light": lodestarColors.buttonDestructive,
                        "ursa-light": ursaColors.red700,
                    },
                    checked: "transparent",
                },
            },
        },
        icon: {
            rest: {
                unchecked: lodestarColors.neutralLight40,
                checked: lodestarColors.neutralLight40,
                outline: "transparent",
            },
            active: {
                unchecked: {
                    "lodestar-light": lodestarColors.neutralLight40,
                    "ursa-light": lodestarColors.neutralLight40,
                },
                checked: {
                    "lodestar-light": lodestarColors.neutralLight40,
                    "ursa-light": lodestarColors.neutralLight40,
                },
            },
            hover: {
                unchecked: {
                    "lodestar-light": lodestarColors.neutralLight40,
                    oldestar: "transparent",
                    "ursa-light": "transparent",
                },
                checked: {
                    "lodestar-light": toRgba(lodestarColors.neutralLight40, 0.6),
                    oldestar: lodestarColors.neutralLight40,
                    "ursa-light": ursaColors.neutral00,
                },
            },
            disabled: {
                unchecked: "transparent",
                checked: {
                    "lodestar-light": lodestarColors.neutralLight40,
                    "ursa-light": ursaColors.neutral00,
                },
                outline: {
                    "lodestar-light": lodestarColors.neutralLight40,
                    "ursa-light": ursaColors.neutral75,
                },
            },
            invalid: {
                rest: lodestarColors.neutralLight40,
                hover: lodestarColors.neutralLight40,
                active: lodestarColors.neutralLight40,
            },
        },
    },
    flag: {
        background: {
            rest: {
                unchecked: "transparent",
                checked: {
                    "lodestar-light": "transparent",
                    "ursa-light": "transparent",
                },
            },
            hover: {
                unchecked: {
                    "lodestar-light": "transparent",
                    "ursa-light": "transparent",
                },
                checked: {
                    "lodestar-light": "transparent",
                    "ursa-light": "transparent",
                },
            },
            active: {
                unchecked: {
                    "lodestar-light": "transparent",
                    "ursa-light": "transparent",
                },
                checked: {
                    "lodestar-light": "transparent",
                    "ursa-light": "transparent",
                },
            },
            disabled: {
                unchecked: "transparent",
                checked: {
                    "lodestar-light": "transparent",
                    "ursa-light": "transparent",
                },
            },
            invalid: {
                // Invalid bg styles are the same as valid bg styles.
                rest: {
                    checked: {
                        "lodestar-light": "transparent",
                        "ursa-light": "transparent",
                    },
                },
                hover: {
                    checked: {
                        "lodestar-light": "transparent",
                        "ursa-light": "transparent",
                    },
                },
                active: {
                    checked: {
                        "lodestar-light": "transparent",
                        "ursa-light": "transparent",
                    },
                },
            },
        },
        border: {
            rest: {
                unchecked: {
                    "lodestar-light": "transparent",
                    "ursa-light": "transparent",
                },
                checked: "transparent",
            },
            hover: {
                unchecked: {
                    "lodestar-light": "transparent",
                    "ursa-light": "transparent",
                },
                checked: "transparent",
            },
            active: {
                unchecked: {
                    "lodestar-light": "transparent",
                    "ursa-light": "transparent",
                },
                checked: "transparent",
            },
            disabled: {
                unchecked: {
                    "lodestar-light": "transparent",
                    "ursa-light": "transparent",
                },
                checked: "transparent",
            },
            invalid: {
                rest: {
                    unchecked: {
                        "lodestar-light": "transparent",
                        "ursa-light": "transparent",
                    },
                    checked: "transparent",
                },
                hover: {
                    unchecked: {
                        "lodestar-light": "transparent",
                        "ursa-light": "transparent",
                    },
                    checked: "transparent",
                },
                active: {
                    unchecked: {
                        "lodestar-light": "transparent",
                        "ursa-light": "transparent",
                    },
                    checked: "transparent",
                },
            },
        },
        icon: {
            rest: {
                unchecked: "transparent",
                checked: {
                    "lodestar-light": lodestarColors.visRedDark10,
                    "ursa-light": ursaColors.orange400,
                },
                outline: {
                    "lodestar-light": lodestarColors.visRedDark10,
                    "ursa-light": ursaColors.neutral200,
                },
            },
            active: {
                unchecked: {
                    "lodestar-light": lodestarColors.neutralLight40,
                    "ursa-light": ursaColors.neutral75,
                },
                checked: {
                    "lodestar-light": lodestarColors.visRedDark10,
                    "ursa-light": ursaColors.orange600,
                },
            },
            hover: {
                unchecked: {
                    "lodestar-light": lodestarColors.neutralLight10,
                    "ursa-light": ursaColors.neutral50,
                },
                checked: {
                    "lodestar-light": lodestarColors.visRedDark10,
                    "ursa-light": ursaColors.orange500,
                },
            },
            disabled: {
                unchecked: "transparent",
                checked: {
                    "lodestar-light": toRgba(lodestarColors.neutralAccessible, 0.4),
                    "ursa-light": ursaColors.orange200,
                },
                outline: {
                    "lodestar-light": toRgba(lodestarColors.neutralAccessible, 0.4),
                    "ursa-light": ursaColors.neutral75,
                },
            },
            invalid: {
                rest: {
                    "lodestar-light": lodestarColors.buttonDestructive,
                    "ursa-light": ursaColors.red500,
                },
                hover: {
                    "lodestar-light": lodestarColors.buttonDestructive,
                    "ursa-light": ursaColors.red600,
                },
                active: {
                    "lodestar-light": lodestarColors.buttonDestructive,
                    "ursa-light": ursaColors.red700,
                },
            },
        },
    },
    star: {
        background: {
            rest: {
                unchecked: "transparent",
                checked: {
                    "lodestar-light": "transparent",
                    "ursa-light": "transparent",
                },
            },
            hover: {
                unchecked: {
                    "lodestar-light": "transparent",
                    "ursa-light": "transparent",
                },
                checked: {
                    "lodestar-light": "transparent",
                    "ursa-light": "transparent",
                },
            },
            active: {
                unchecked: {
                    "lodestar-light": "transparent",
                    "ursa-light": "transparent",
                },
                checked: {
                    "lodestar-light": "transparent",
                    "ursa-light": "transparent",
                },
            },
            disabled: {
                unchecked: "transparent",
                checked: {
                    "lodestar-light": "transparent",
                    "ursa-light": "transparent",
                },
            },
            invalid: {
                // Invalid bg styles are the same as valid bg styles.
                rest: {
                    checked: {
                        "lodestar-light": "transparent",
                        "ursa-light": "transparent",
                    },
                },
                hover: {
                    checked: {
                        "lodestar-light": "transparent",
                        "ursa-light": "transparent",
                    },
                },
                active: {
                    checked: {
                        "lodestar-light": "transparent",
                        "ursa-light": "transparent",
                    },
                },
            },
        },
        border: {
            rest: {
                unchecked: {
                    "lodestar-light": "transparent",
                    "ursa-light": "transparent",
                },
                checked: "transparent",
            },
            hover: {
                unchecked: {
                    "lodestar-light": "transparent",
                    "ursa-light": "transparent",
                },
                checked: "transparent",
            },
            active: {
                unchecked: {
                    "lodestar-light": "transparent",
                    "ursa-light": "transparent",
                },
                checked: "transparent",
            },
            disabled: {
                unchecked: {
                    "lodestar-light": "transparent",
                    "ursa-light": "transparent",
                },
                checked: "transparent",
            },
            invalid: {
                rest: {
                    unchecked: {
                        "lodestar-light": "transparent",
                        "ursa-light": "transparent",
                    },
                    checked: "transparent",
                },
                hover: {
                    unchecked: {
                        "lodestar-light": "transparent",
                        "ursa-light": "transparent",
                    },
                    checked: "transparent",
                },
                active: {
                    unchecked: {
                        "lodestar-light": "transparent",
                        "ursa-light": "transparent",
                    },
                    checked: "transparent",
                },
            },
        },
        icon: {
            rest: {
                unchecked: "transparent",
                checked: {
                    "lodestar-light": lodestarColors.visYellow,
                    "ursa-light": ursaColors.gold500,
                },
                outline: {
                    "lodestar-light": lodestarColors.visYellow,
                    "ursa-light": ursaColors.neutral200,
                },
            },
            active: {
                unchecked: {
                    "lodestar-light": lodestarColors.neutralLight40,
                    "ursa-light": ursaColors.neutral75,
                },
                checked: {
                    "lodestar-light": lodestarColors.visYellow,
                    "ursa-light": ursaColors.gold700,
                },
            },
            hover: {
                unchecked: {
                    "lodestar-light": lodestarColors.neutralLight10,
                    "ursa-light": ursaColors.neutral50,
                },
                checked: {
                    "lodestar-light": lodestarColors.visYellow,
                    "ursa-light": ursaColors.gold600,
                },
            },
            disabled: {
                unchecked: "transparent",
                checked: {
                    "lodestar-light": toRgba(lodestarColors.neutralAccessible, 0.4),
                    "ursa-light": ursaColors.gold200,
                },
                outline: {
                    "lodestar-light": toRgba(lodestarColors.neutralAccessible, 0.4),
                    "ursa-light": ursaColors.neutral75,
                },
            },
            invalid: {
                rest: {
                    "lodestar-light": lodestarColors.buttonDestructive,
                    "ursa-light": ursaColors.red500,
                },
                hover: {
                    "lodestar-light": lodestarColors.buttonDestructive,
                    "ursa-light": ursaColors.red600,
                },
                active: {
                    "lodestar-light": lodestarColors.buttonDestructive,
                    "ursa-light": ursaColors.red700,
                },
            },
        },
    },
});

export const checkboxBorderTheme = themed({
    borderRadius: {
        "lodestar-light": border.radius05,
        "ursa-light": border.radius20,
    },
});

export const checkboxMotionTheme = themed({
    background: {
        "lodestar-light": "",
        "ursa-light": `background-color ${motion.animation.default}, color ${motion.animation.default}`,
    },
    flag: "",
    star: "",
    check: {
        "lodestar-light": "",
        "ursa-light": `stroke-dashoffset 4500ms ${motion.easing.default} 100ms`,
    },
});

export const checkboxLabelTheme = themed({
    color: {
        rest: "inherit",
        disabled: {
            "lodestar-light": toRgba(lodestarColors.neutralDark40, 0.4),
            "ursa-light": ursaColors.neutral300,
        },
    },
    gap: {
        "lodestar-light": "8px",
        "ursa-light": "6px",
    },
    fontWeight: {
        "lodestar-light": typography.fontWeight.regular,
        "ursa-light": typography.fontWeight.medium,
    },
});

export const checkmarkTheme = themed({
    size: {
        16: {
            "lodestar-light": 16,
            // The icon in ursa is always 20px.
            "ursa-light": 20,
        },
        20: {
            "lodestar-light": 20,
            "ursa-light": 20,
        },
    } as const,
});
